import { useRef } from "react";
import { cn } from "@lib/utils";
import googleLogo from "@assets/google_logo.png";

interface GoogleOAuthButtonProps {
  csrfToken: string;
  oauthPath: string;
  label: string;
  className?: string;
  /**
   * Cloudflare Turnstile token. Read lazily on click (not render) so the
   * latest token is sent — Turnstile auto-refreshes before expiry.
   */
  getTurnstileToken?: () => string | undefined;
  disabled?: boolean;
}

export function GoogleOAuthButton({ csrfToken, oauthPath, label, className, getTurnstileToken, disabled }: GoogleOAuthButtonProps) {
  const formRef = useRef<HTMLFormElement>(null);
  const turnstileInputRef = useRef<HTMLInputElement>(null);

  function handleClick() {
    if (turnstileInputRef.current) {
      turnstileInputRef.current.value = getTurnstileToken?.() ?? "";
    }
    formRef.current?.submit();
  }

  return (
    <>
      <form ref={formRef} method="post" action={oauthPath} className="hidden">
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <input ref={turnstileInputRef} type="hidden" name="cf-turnstile-response" value="" />
      </form>
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className={cn(
          "flex h-12 w-full items-center justify-center gap-2.5 rounded-lg border border-neutral-600 bg-base-600 px-3 text-sm font-medium text-neutral-100 hover:bg-base-500 disabled:cursor-not-allowed disabled:opacity-60",
          className
        )}
      >
        <img src={googleLogo} alt="" className="h-5 w-5" />
        {label}
      </button>
    </>
  );
}
